import Request from "@/Request";

export function dashbaordData(payload) {
  return Request({
    url: "/dashboard",
    method: "get",
    params: payload,
  });
}

export function partyDashbaordData() {
  return Request({
    url: "/dashboard/parties",
    method: "get",
  });
}